import useMappingOptions from '../useMappingOptions/index.js';
import useSystemEnums from '../useSystemEnums/index.js';

var useStationStatus = function () {
    var stationStatusEnum = useSystemEnums(function (s) { return s.station_status; }) || {};
    var _a = useMappingOptions(stationStatusEnum), stationStatusMapping = _a.mapping, stationStatusOptions = _a.options;
    return {
        stationStatusEnum: stationStatusEnum,
        stationStatusMapping: stationStatusMapping,
        stationStatusOptions: stationStatusOptions,
    };
};

export { useStationStatus as default };
